import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import { handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
import addressService from "../services/address.service";

export const addAddress = createAsyncThunk(
  "address/create",
  async (
    { data, callBack = null }: { data: any; callBack?: any },
    { dispatch, getState }
  ) => {
    try {
      const reducer: any = getState();
      dispatch(setAddingAddress(true));
      const resp: any = await addressService.addAddress({ body: data }); //postAPICall(nextAPIRoutes.ADD_ADDRESS, data)
      dispatch(setAddingAddress(false));
      dispatch(getAddress());
      dispatch(setSelectedAddress(resp?.data?.data?.id ?? ""));
      if (callBack) {
        callBack(resp?.data?.data?.id);
      }

      if (reducer?.addressReducer?.savedAddress === 0) {
        dispatch(
          makeDefaultAddress({ id: resp?.data?.data?.id, callBack: () => {} })
        );
      }
      return resp.data.data ?? [];
    } catch (e: any) {
      console.log(e);
      dispatch(setAddingAddress(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const editAddress = createAsyncThunk(
  "address/edit",
  async (
    { id, data, callBack = null }: { id: any; data: any; callBack?: any },
    { dispatch }
  ) => {
    try {
      dispatch(setAddingAddress(true));
      const resp: any = await addressService.editAddress({
        body: data,
        params: { id },
      }); //postAPICall(nextAPIRoutes.ADD_ADDRESS, data)
      dispatch(setAddingAddress(false));
      dispatch(getAddress());
      if (callBack) {
        callBack(resp?.data?.data?.id);
      }
      return resp.data.data ?? [];
    } catch (e: any) {
      console.log(e);
      dispatch(setAddingAddress(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const deleteAddress = createAsyncThunk(
  "address/edit",
  async ({ id }: { id: any }, { dispatch }) => {
    try {
      const resp: any = await addressService.deleteAddress({
        params: { id },
      });
      dispatch(getAddress());

      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);
export const getAddress = createAsyncThunk(
  "address/fetch",
  async (_, { dispatch }) => {
    try {
      const resp: any = await addressService.getAddress({}); //postAPICall(nextAPIRoutes.FETCH_ADDRESS, {})
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const makeDefaultAddress = createAsyncThunk(
  "address/default",
  async ({ id, callBack }: { id: any; callBack: any }, { dispatch }) => {
    try {
      const resp: any = await addressService.makeDefaultAddress({
        params: { id },
      });
      callBack();
      dispatch(getAddress());

      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const addressSlice = createSlice({
  name: "address",
  initialState: {
    addingAddress: false,
    savedAddress: [] as any,
    selectedAddress: "",
  },
  reducers: {
    setAddingAddress: (state, { payload }) => {
      state.addingAddress = payload;
    },
    setSelectedAddress: (state, { payload }) => {
      state.selectedAddress = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAddress.fulfilled, (state, { payload }) => {
      state.savedAddress = payload;
    });
  },
});

export default addressSlice.reducer;
export const { setAddingAddress, setSelectedAddress } = addressSlice.actions;
